import { useAuthStore } from '@/store/authStore'

export function checkPermission(permissionsRequired) {
  return useAuthStore().hasPermission(permissionsRequired)
}
